var chunkMapping = {
	"1262": [
		51262
	],
	"3214": [
		3214
	],
	"3243": [
		93243
	],
	"3785": [
		93785
	],
	"4638": [
		24638
	],
	"5396": [
		45396
	],
	"5501": [
		45501
	],
	"5944": [
		85944
	],
	"7201": [
		37201
	],
	"7226": [
		57226
	],
	"7327": [
		67327
	],
	"7545": [
		57545
	],
	"8847": [
		8847
	],
	"9541": [
		49541
	],
	"9597": [
		99597
	],
	"9850": [
		29850
	]
};
var idToExternalAndNameMapping = {
	"3214": [
		"default",
		"./AvailabilityDetails",
		78460
	],
	"8847": [
		"default",
		"./SavedCartsList",
		6929
	],
	"24638": [
		"default",
		"./AlternativesButtonWithModal",
		22186
	],
	"29850": [
		"default",
		"./StoreListItem",
		27600
	],
	"37201": [
		"default",
		"./MiniCartSelector",
		6929
	],
	"45396": [
		"default",
		"./BulkDiscountLabel",
		22186
	],
	"45501": [
		"default",
		"./BulkDiscountTiersDisplay",
		22186
	],
	"49541": [
		"default",
		"./SideCaddy",
		6929
	],
	"51262": [
		"default",
		"./StoreListTilesRow",
		27600
	],
	"57226": [
		"default",
		"./Banner",
		27600
	],
	"57545": [
		"default",
		"./LoginPrompt",
		27600
	],
	"67327": [
		"default",
		"./GlobalHeader",
		78460
	],
	"85944": [
		"default",
		"./Recommendations",
		27600
	],
	"93243": [
		"default",
		"./AddToCart",
		6929
	],
	"93785": [
		"default",
		"./UidispatcherApiModule",
		56190
	],
	"99597": [
		"default",
		"./IdamCompatibleLogoutLink",
		27600
	]
};
var idToRemoteMap = {
	"3214": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"8847": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"24638": [
		{
			"externalType": "script",
			"name": "sd_pdp_ui",
			"externalModuleId": 22186
		}
	],
	"29850": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"37201": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"45396": [
		{
			"externalType": "script",
			"name": "sd_pdp_ui",
			"externalModuleId": 22186
		}
	],
	"45501": [
		{
			"externalType": "script",
			"name": "sd_pdp_ui",
			"externalModuleId": 22186
		}
	],
	"49541": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"51262": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"57226": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"57545": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"67327": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"85944": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	],
	"93243": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"93785": [
		{
			"externalType": "script",
			"name": "uidispatcher_api",
			"externalModuleId": 56190
		}
	],
	"99597": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui",
			"externalModuleId": 27600
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}